import { useEffect, useState } from 'react';

/**
 * Hook to track fullscreen state and return the fullscreen element.
 * Used to place portals for popovers and dialogs in fullscreen mode.
 */
export default function useFullscreenContainer(): Element | undefined {
  const [fullscreenElement, setFullscreenElement] = useState<Element | null>(
    () => document.fullscreenElement,
  );

  useEffect(() => {
    const handleFullscreenChange = () => {
      setFullscreenElement(document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  return fullscreenElement || undefined;
}
